<template>
  <section :class="$style.open_hour">
    <div :id="$style.opening_hours">
      <div :id="$style.sub_title">
        <h2>
          3. 入館者55万人達成記念イベント <br />
          <h3>(10分)</h3>
        </h2>
      </div>
    </div>
    <br />
    2010年1月10日に行われた松井秀喜ベースボールミュージアム<br />
    入館者55万人達成記念イベントの模様です。松井選手本人の解説によるミュージアム見学会が行われました。
  </section>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "OpenHourVisual",
  components: {},
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .open_hour {
    text-align: center;

    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
      h3 {
        font-size: 20px;
      }
    }
    .middle_title {
      font-size: 18px;
      color: #46ca0e;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .open_hour {
    text-align: center;

    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }

      #sub_title {
        color: #3b342a;
        h3 {
          font-size: 23px;
        }
      }
    }
    .middle_title {
      font-size: 18px;
      color: #46ca0e;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
</style>
